import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    searchbar: {
        backgroundColor: 'whitesmoke',
        opacity: '60%',
        width: '200px',
        borderWidth: '0px',
        borderRadius: '5px',
    },
    adornment: {
        marginRight: '5px',
    },
    notchedOutline: {
        border: 'none', // Remove the border
    },
}));
